<template>
    <BarChart ref="BarChart"></BarChart>
</template>

<script>
import VueCharts from 'vue-chartjs'

export default {
    name: 'TimelineChart',
    components: { BarChart: VueCharts.Bar },
    props: {
        dataSets: {
            type: Array,
            default () {
                return []
            }
        },
        labels: {
            type: Array,
            default () {
                return []
            }
        },
        isBot: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        dataSets () {
            this.renderChart()
        }
    },
    mounted () {
        this.renderChart()
    },
    methods: {
        renderChart () {
            if (this.$refs.BarChart) {
                this.$refs.BarChart.renderChart({
                    labels: this.labels,
                    datasets: this.dataSets
                }, {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        mode: 'index',
                        intersect: false
                    },
                    hover: {
                        mode: 'nearest',
                        intersect: true
                    },
                    legend: {
                        position: 'bottom'
                    },
                    plugins: {
                        datalabels: {
                            formatter: () => ''
                        }
                    },
                    scales: {
                        yAxes: [{
                            type: 'linear',
                            display: true,
                            stacked: true,
                            position: 'left',
                            id: 'y-axis-1',
                            scaleLabel: {
                                display: true,
                                labelString: (this.isBot ? 'Bot' : 'Agent') + ' rating times'
                            },
                            gridLines: {
                                drawOnChartArea: false
                            }
                        }, {
                            type: 'linear',
                            display: true,
                            stacked: true,
                            position: 'right',
                            id: 'y-axis-2',
                            scaleLabel: {
                                display: true,
                                labelString: 'Message rating times'
                            },
                            gridLines: {
                                drawOnChartArea: false
                            }
                        }]
                    }
                })
            }
        }
    }
}
</script>

<style scoped>

</style>
